import _isArray from 'ramda/src/internal/_isArray';

/**
 * Checks if input value is `Array`.
 *
 * @func isArray
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.3.0|v0.3.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {Boolean}
 * @see {@link RA.isNotArray|isNotArray}
 * @example
 *
 * RA.isArray([]); //=> true
 * RA.isArray(null); //=> false
 * RA.isArray({}); //=> false
 */
var isArray = Array.isArray || _isArray;

export default isArray;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/isArray.js
// module id = 76
// module chunks = 0